/** Word wheel play grid size. Must match backend `WordWheelGridLayoutService.GRID_SIZE`. */
export const GRID_SIZE = 8;

export const WORD_WHEEL_SEASON = "season_2026";
export const WORD_WHEEL_APP_CODE = "word_wheel_quest";
export const WORD_WHEEL_CREDIT_COST = 1;
export const WORD_WHEEL_COIN_HINT_COST = 10;
export const WORD_WHEEL_BONUS_WORD_GIFT = 1;
export const GUEST_JOURNEY_LEVEL_KEY = "ww_web_guest_journey_level";
export const GUEST_PUZZLE_COINS_KEY = "ww_web_guest_puzzle_coins";

export function resolveWordWheelGridSize(puzzleOrSize) {
    if (puzzleOrSize != null && typeof puzzleOrSize === "object") {
        const n = Number(puzzleOrSize.gridSize);
        if (Number.isFinite(n) && n > 0) return n;
    } else {
        const n = Number(puzzleOrSize);
        if (Number.isFinite(n) && n > 0) return n;
    }
    return GRID_SIZE;
}

export function getGuestJourneyLevel() {
    try {
        const n = Number(sessionStorage.getItem(GUEST_JOURNEY_LEVEL_KEY) || "1");
        return Number.isFinite(n) && n >= 1 ? Math.floor(n) : 1;
    } catch {
        return 1;
    }
}

export function setGuestJourneyLevel(level) {
    const n = Number(level);
    if (!Number.isFinite(n) || n < 1) return;
    try {
        sessionStorage.setItem(GUEST_JOURNEY_LEVEL_KEY, String(Math.floor(n)));
    } catch {
        /* ignore */
    }
}

export function guestDailyFoundKey(date) {
    return `ww_web_guest_daily_${date || "today"}`;
}
